import { render, staticRenderFns } from "./InspectionAttachments.vue?vue&type=template&id=064a4342&scoped=true&"
import script from "./InspectionAttachments.vue?vue&type=script&lang=js&"
export * from "./InspectionAttachments.vue?vue&type=script&lang=js&"
import style0 from "./InspectionAttachments.vue?vue&type=style&index=0&id=064a4342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064a4342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064a4342')) {
      api.createRecord('064a4342', component.options)
    } else {
      api.reload('064a4342', component.options)
    }
    module.hot.accept("./InspectionAttachments.vue?vue&type=template&id=064a4342&scoped=true&", function () {
      api.rerender('064a4342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/Inspection/InspectionAttachments.vue"
export default component.exports